<template>
  <div id="app">
    <T1HeadScripts rodzajstrony="front" />
    <a-layout id="components-layout-demo-top" class="layout">
      <T1Header />
      <T1Content />
      <!-- <T1Newsletter /> -->
      <div width="auto" class="container">
	      <div class="title"> W Roku 2025 dalej spełniamy Marzenia naszych Klientów </div>
      <a href="https://www.travelone.pl/rodzaj-oferty.xml">
	      <img src="/imgs/t1logoziemia.jpg" width="851px" height="315px"/>
	</a>
      </div>
      <T1Footer />
    </a-layout>
  </div>
</template>

<script>
import T1HeadScripts from "./components/T1HeadScripts";
import T1Header from "./components/T1Header/T1Header";
import T1Content from "./components/T1Content";
// import T1Newsletter from "./components/T1Newsletter";
import T1Footer from "./components/T1Footer/T1Footer";

export default {
  name: "app",
  components: {
    T1HeadScripts,
    T1Header,
    T1Content,
    // T1Newsletter,
    T1Footer
  },
  mounted() {
    console.log("ENV: " + `${process.env.VUE_APP_URI}`);
  }
};
</script>

<style>
.container img[src="/imgs/t1logoziemia.jpg"] {
    width: 851px;
    margin: auto;
    display: block;
    padding-bottom: 1%;
	@media (max-width: 680px) {
    padding: 0 16px 0;
    width: 280px;
    content: url("/imgs/t1logoziemia.jpg");
   }
}
.container .title {
    	
    font-size: 30px;
    font-weight: 30px;
    color: black;
    margin: auto;
    text-align: center;
}
</style>
